import React, { Component } from 'react';
import { Modal, message,Button,DatePicker,Checkbox,Spin } from 'antd';

const CheckboxGroup = Checkbox.Group;

import API_URL from '../../../common/url';
import $ from '../../../common/AjaxRequest';

import '../style.less';

import {
    SortableContainer,
    SortableElement,
    arrayMove,
} from "react-sortable-hoc";



let type = 'PREPAID_FEE';

class FieldSettingsModel extends React.Component {
    state = {
        visible: false,
        loading: false,
        searchParams:{},
        sortParams: {},
        pagination: {
            pageSize: 10,
            current: 1,
        },
        data: [],
        checkedList: [],
        //indeterminate: true,
        checkAll: true,
    }

    show = () => {
        this.setState({
            data: [],
            visible: true,
        }, () => {
            this.loadData();
        });
    }

    loadData = () => {
        const{searchParams}=this.props;
        const{dateStart,dateEnd}=searchParams;
        const{checkAll}=this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.common.queryUserCustomDisplayByUserId,
            data: { type,dateStart,dateEnd },
            dataType: 'json',
            doneResult: res => {
                const dataArry = res[type] || [];
                this.setState({
                    data: dataArry,
                    loading: false,
                });
                for (let i = 0, len = dataArry.length; i < len; i++) {
                    const { isShow } = dataArry[i];
                    if(isShow=="0"){
                        this.setState({
                            checkAll: false,
                        });
                    }
                }    
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    hide = () => {
        this.setState({ visible: false,data:[] });
    }




      onCheckAllChange = (e) => {
        this.setState({
          checkAll: e.target.checked,
        });
        const{data=[]}=this.state;
        data.map((item, index) =>{
         if(item.isDefault!=1){
            data[index].isShow = e.target.checked ? 1 : 0
         }
         this.setState({
            data 
         })         
        })
      }

      onSortEnd = ({ oldIndex, newIndex }) => {
        const { data } = this.state;
        this.setState({ data: arrayMove(data, oldIndex, newIndex) })
    }

    onCheckChange = (e, index) => {
        const { data } = this.state;
        data[index].isShow = e.target.checked ? 1 : 0;

        if(e.target.checked==false){
            this.setState({ checkAll:false });
            this.setState({ data });
        }else{
            this.setState({ data },
                () => {
                    const selectAll = data.every(i => i.isShow == 1);
                    if(selectAll){
                        this.setState({ checkAll:true });
                    } 
                }  
                );
        }
    }

    handleSubmit = () => {
        const { data } = this.state;
        this.setState({ loading: true });
        
        const params = {};
        data.forEach((column, index) => {
            const { isShow, userCustomDisplayDefineId, displayType } = column;
            params[`customDisplayDefines[${index}].userCustomDisplayDefineId`] = userCustomDisplayDefineId;
            params[`customDisplayDefines[${index}].isShow`] = isShow;
            params[`customDisplayDefines[${index}].displayType`] = displayType;
            params[`customDisplayDefines[${index}].sortIndex`] = index;
        });

        const options = {
            method: 'POST',
            url: API_URL.common.saveUserCustomDisplayValueAndSort,
            data: {
                ...params,
                type
            },
            dataType: 'json',
            doneResult: (res) => {
                message.success(res.success);
                this.setState({ loading: false }, () => {
                    this.hide();
                    this.props.queryHead();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        }
        $.sendRequest(options)
    }

    render() {
        const { data,visible, loading, } = this.state;


        
        const SortableList = SortableContainer(({ list }) => {
            return (
                <div className="degreesort">
                    {list.map((item, index) =>
                        <SortableItem
                            key={`item-${index}`}
                            curIndex={index}
                            item={item}
                            disabled={(item.isDefault == 1)&&item.dataIndex=="recordYearMonthShow"}
                            index={index}
                        />
                    )}
                </div>
            );
        });

        const SortableItem = SortableElement(({ item,curIndex }) => {
            const { isShow, title, dataIndex, isDefault } = item;
            return (
                <div className="sortgrid-item fieldSetting_item">
                    <div className={`sortitem ${item.isDefault == 1 ? 'disabled' : ''} notSelectWords`}  key={dataIndex}>
                        {/* {item.title} */}
                        <Checkbox
                         disabled={isDefault == 1}
                         checked={isShow == 1}
                         onChange={(e) => this.onCheckChange(e, curIndex)}
                         style={(item.isDefault == 1)&&item.dataIndex=="recordYearMonthShow"?{background:"#f3f1f1"}:null}
                        > <span title={title} className="fieldSetting_text">{title}</span>
                        </Checkbox>
                    </div>
                </div>
            );
        });

        return (
            <Modal
                title="自定义显示-字段排序"
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={this.hide}
                className="create-modal"
                wrapClassName="vertical-center-modal"
                width="1000px"
                loading={loading}
                // footer={[
                //     <Button key="back" size="large" onClick={this.hide}>关闭</Button>,
                // ]}
            >
              <Spin spinning={loading}>
               {data.length>0?   
               <div>

               <div>
               <Checkbox
                //indeterminate={this.state.indeterminate}
                onChange={this.onCheckAllChange}
                checked={this.state.checkAll}
               >
                <span>全选<span style={{color:"red"}}>（拖动字段可以调整字段顺序）</span></span>
              </Checkbox>
              </div>

              <br />
                  <SortableList
                        list={data}
                        distance={10}
                        axis="xy"
                        helperClass="sortHelper"
                        onSortEnd={this.onSortEnd}
                    />
               </div>
               :
               "暂无字段设置"
               }
               </Spin>
            </Modal>
        );
    }
}

export default FieldSettingsModel;


// WEBPACK FOOTER //
// ./src/components/financeManagement/otherChargesReport/FieldSettingsModel.js